<template>
  <v-container>
    <equipment-tab></equipment-tab>
    <v-container>
      <base-material-card
        v-if="filteredHistoryList"
        icon="mdi-clipboard-text-outline"
        color="primary"
        inline
        class="px-5 my-12 py-3"
      >
        <template v-slot:after-heading>
          <div class="title text-no-wrap font-weight-bold">
            {{ $t("repairList.repairList") }}
          </div>
        </template>

        <v-data-table
          @click:row="goToPartProfile"
          loading-text="Loading... Please wait"
          :headers="headers"
          :items="filteredHistoryList"
          :footer-props="{
            itemsPerPageText: $t('repairList.itemsPerPage'),
            itemsPerPageAllText: $t('repairList.itemsPerPageAllText')
          }"
        >
          <template v-slot:[`item.taskDate`]="{ item }">
            {{ item.taskDate }}
          </template>
        </v-data-table>
      </base-material-card>
    </v-container></v-container
  >
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      tab: null,
      fab: false,
      search: "",
      selectedFilters: ["repair"],
      colorChips: {
        CREATED: "success",
        UPDATE: "blue",
        REPAIR: "primary"
      },
      todayTaskSample: {
        id: "TODAY",
        taskDate: new Date(),
        showHeader: true
      },
      headers: [
        {
          text: this.$t("repairList.headers.taskName"),
          value: "name"
        },
        {
          text: this.$t("repairList.headers.taskDescription"),
          value: "description"
        },
        { text: this.$t("repairList.headers.taskDate"), value: "taskDate" }
      ],
      colors: {
        green: "#008450",
        yellow: "#EFB700",
        red: "#B81D13"
      },
      timeObject: [
        ["year", 31536000],
        ["month", 2592000],
        ["week", 86400 * 7],
        ["day", 86400],
        ["hour", 3600],
        ["minute", 60],
        ["second", 1]
      ],
      legendList: [
        {
          title: "Overdue",
          color: "#B81D13"
        },
        {
          title: "To Expire",
          color: "#EFB700"
        },
        {
          title: "On Time",
          color: "#008450"
        }
      ]
    };
  },
  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square"
    });
    await this.$store.dispatch(
      "calendar/bindEquipmentEvents",
      this.$route.params.id
    );

    loading.close();
  },
  computed: {
    ...mapState("calendar", ["events"]),
    ...mapState("auth", ["user"]),

    historyList() {
      if (this.events) {
        let realList = [];

        let temporalEvents = [...this.events];

        temporalEvents.forEach(task => {
          // For unique tasks
          if (task.type === "unique" && task.isDone) {
            let date = task.start.split("-");
            date.reverse();
            realList.push({
              id: task.id,
              name: task.name,
              type: task.type,
              subtype: task.subtype,
              taskDate: date.join("/"),
              description: task.description || task.details,
              lastTime: task.lastChange,
              changeTime: task.changeTime,
              alertTime: task.alertTime,
              disabledArray: task.disabledArray
            });
          }
        });
        realList.sort(function(a, b) {
          if (b.id === "TODAY" && a.taskDate.getDate() === b.taskDate.getDate())
            return 1;
          return +a.taskDate < +b.taskDate ? -1 : 1;
        });
        return realList;
      }
      return [];
    },

    filteredHistoryList() {
      return this.historyList.filter(task => {
        const isToday = task.id === "TODAY";
        const isInFilters = this.selectedFilters.includes(task.subtype);

        const isInSearch =
          task?.name?.toLowerCase().includes(this.search.toLowerCase()) ||
          task?.subtype?.toLowerCase().includes(this.search.toLowerCase()) ||
          task?.type?.toLowerCase().includes(this.search.toLowerCase()) ||
          task?.description?.toLowerCase().includes(this.search.toLowerCase());

        return isToday || (isInSearch && isInFilters);
      });
    }
  },
  methods: {
    getSimpleDate(date) {
      const jsDate = new Date(date);
      const year = jsDate.getFullYear();
      const month = jsDate.getMonth();
      const day = jsDate.getDate();

      return `${year}-${month}-${day}`;
    },
    goToPartProfile(task) {
      this.$router.push({
        name: "TaskProfile",
        params: {
          id: task.id,
          uniqueId: task.uniqueId ? task.uniqueId : "N/A",
          taskDate: task.taskDate ? task.taskDate : "N/A"
        }
      });
    }
  }
};
</script>
